import Vue from 'vue';

/**
 * @description Селекторы таббируемых элементов.
 * @type {string[]}
 */
const tabbableSelectors = [
  '[autofocus]',
  '[contenteditable]',
  '[tabindex]',
  'a[href]',
  'area[href]',
  'audio[controls]',
  'button:enabled',
  'embed',
  'iframe',
  'input:enabled:not([type="hidden"])',
  'object',
  'select:enabled',
  'summary',
  'textarea:enabled',
  'video[controls]',
];

/**
 * @description Запрос таббируемых элементов.
 * @type {string}
 */
export const queryTabbables = tabbableSelectors.join(',');

/**
 * @description Получить первый таббируемый элемент по родительскому.
 * @param {HTMLElement} parentElement Родительский элемент.
 * @returns {(HTMLElement|null)}
 */
function getFirstTabbableElementByParent(parentElement) {
  return parentElement.querySelector(queryTabbables);
}

/**
 * @description Сфокусировать элемент.
 * @param {HTMLElement} element Элемент.
 * @returns {void}
 */
export function focusElement(element) {
  Vue.nextTick(() => element.focus());
}

/**
 * @description Сопоставить элемент к HTMLElement.
 * @param {any} candidate Кандидат.
 * @returns {(HTMLElement|null)}
 */
function matchElement(candidate) {
  if (typeof candidate === 'object' && candidate instanceof HTMLElement) {
    return candidate;
  }
  return null;
}

export default {
  methods: {
    /**
     * @description Сфокусировать элемент ввода или управляющий элемент.
     * @param {HTMLElement} parentElement Родительский элемент.
     * @returns {void}
     */
    focusIn(parentElement) {
      if (matchElement(parentElement) !== null) {
        focusElement(getFirstTabbableElementByParent(parentElement));
      }
    },
  },
};
